var render = function render(){var _vm=this,_c=_vm._self._c;return _c('landing-form',{ref:"contactForm",attrs:{"prefilled-model":_vm.prefilledModel,"landing-name":_vm.landingName}})
}
var staticRenderFns = []

export { render, staticRenderFns }